<template>
  <!-- eslint-disable -->
  <SnackBar ref="snackbar" />
  <v-container fluid>
    <div class="flex-title">
      <v-btn
        style="background: #f9f8f8; font-size: 18px"
        size="small"
        @click="this.$router.go(-1)"
        icon
      >
        <v-icon color="#004984">mdi-arrow-left</v-icon>
      </v-btn>
      <h1 class="contribuicao-text">{{nomeProjeto}} - Contribuições no Github</h1>
      <v-icon>mdi-github</v-icon>
    </div>

    <v-divider class="mx-4" inset vertical></v-divider>

    <v-tabs v-model="tab" align-tabs="center" slider-color="#004984">
      <v-tab class="v-tab" :value="1"> Visão Detalhada </v-tab>
      <v-tab class="v-tab" :value="2"> Visão Resumida </v-tab>
    </v-tabs>

    <v-window v-model="tab">
      <v-window-item :value="1" class="mt-10">
        <!-- Descricao -->
        <v-row>
          <v-col>
            <p>
              Selecione as opções abaixo para visualizar as contribuições para o
              projeto.
            </p>
          </v-col>
        </v-row>

        <!-- Filtros -->
        <v-row>
          <v-col>
            <v-row align="center">
              <v-col>
                <v-select
                  label="Visão"
                  v-model="visaoSelecionadaDetalhada"
                  :items="visao"
                  prepend-inner-icon="mdi-eye"
                  variant="solo"
                  rounded
                  clearable
                  hide-no-data
                  hide-details
                  return-object
                  @update:modelValue="onVisaoChangeDetalhada"
                ></v-select>
              </v-col>

              <v-tooltip text="Escolha uma visão" location="right">
                <template #activator="{ props }">
                  <v-icon v-bind="props" size="small">
                    mdi-information-outline
                  </v-icon>
                </template>
                <template #default>
                  <div class="custom-tooltip">
                    <span
                      >Defina uma visão para visualizar as contribuições do
                      Github.</span
                    >
                  </div>
                </template>
              </v-tooltip>
            </v-row>
          </v-col>

          <v-col>
            <v-row align="center">
              <v-col>
                <v-select
                  label="Repositórios"
                  :no-data-text="'Esse projeto não possui repositórios associados.'"
                  v-model="repositorioSelecionado"
                  :items="repositorios"
                  item-text="title"
                  item-value="repo"
                  prepend-inner-icon="mdi-book"
                  variant="solo"
                  rounded
                  clearable
                  hide-no-data
                  hide-details
                  :disabled="!isVisaoSelectedDetalhada"
                  @update:modelValue="onRepositorioChange"
                ></v-select>
              </v-col>

              <v-tooltip location="right">
                <template #activator="{ props }">
                  <v-icon v-bind="props" size="small">
                    mdi-information-outline
                  </v-icon>
                </template>
                <template #default>
                  <div class="custom-tooltip">
                    <span
                      >Quando o repositório não for selecionado, são
                      considerados <strong>todos</strong> os repositórios do
                      projeto.</span
                    >
                  </div>
                </template>
              </v-tooltip>
            </v-row>
          </v-col>

          <v-col>
            <v-row align="center">
              <v-col>
                <v-autocomplete
                  label="Branches"
                  v-model="branchesSelecionada"
                  :items="branches"
                  item-title="name"
                  item-value="name"
                  prepend-inner-icon="mdi-source-branch"
                  variant="solo"
                  rounded
                  clearable
                  hide-no-data
                  hide-details
                  :disabled="!isRepositorioSelected"
                ></v-autocomplete>
              </v-col>

              <v-tooltip location="right">
                <template #activator="{ props }">
                  <v-icon v-bind="props" size="small">
                    mdi-information-outline
                  </v-icon>
                </template>
                <template #default>
                  <div class="custom-tooltip">
                    <span
                      >Caso a branch não seja selecionada, é feita a busca pela
                      branch <strong>'dev'</strong> do repositório.</span
                    >
                  </div>
                </template>
              </v-tooltip>
            </v-row>
          </v-col>

          <v-col>
            <v-row align="center">
              <v-col>
                <v-autocomplete
                  label="Desenvolvedores"
                  v-model="desenvolvedorSelecionado"
                  :items="
                    desenvolvedores.map((desenvolvedor) => ({
                      title: desenvolvedor.usuario_git,
                      image: desenvolvedor.img_url,
                    }))
                  "
                  prepend-inner-icon="mdi-account-search"
                  variant="solo"
                  rounded
                  clearable
                  hide-no-data
                  hide-details
                  :disabled="!isVisaoSelectedDetalhada"
                  item-value="title"
                >
                  <template v-slot:item="{ props, item }">
                    <v-list-item
                      v-bind="props"
                      open-on-clear
                      :prepend-avatar="item?.raw?.image"
                      :title="item?.raw?.title"
                    ></v-list-item>
                  </template>
                  <template #selection="{ item }">
                    <v-chip size="small">
                      <v-avatar size="18" style="margin-right: 5px">
                        <img
                          :src="item.raw.image"
                          alt="User Image"
                          class="icon-user"
                        />
                      </v-avatar>
                      <span>{{ item.title }}</span>
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-tooltip location="right">
                <template #activator="{ props }">
                  <v-icon v-bind="props" size="small">
                    mdi-information-outline
                  </v-icon>
                </template>
                <template #default>
                  <div class="custom-tooltip">
                    <span
                      >Quando o desenvolvedor não for selecionado, são
                      considerados <strong>todos</strong> os desenvolvedores do
                      projeto.</span
                    >
                  </div>
                </template>
              </v-tooltip>
            </v-row>
          </v-col>

          <v-col>
            <v-row align="center">
              <v-col>
                <VueDatePicker
                  v-model="date"
                  range
                  placeholder="Período"
                  auto-apply
                  :max-date="new Date()"
                  :enable-time-picker="false"
                  :format="format"
                  :disabled="!isVisaoSelectedDetalhada"
                />
              </v-col>
              <v-tooltip location="right">
                <template #activator="{ props }">
                  <v-icon v-bind="props" size="small">
                    mdi-information-outline
                  </v-icon>
                </template>
                <template #default>
                  <div class="custom-tooltip">
                    <span
                      >Caso não seja selecionado o período, é feita a busca
                      desde o início do projeto.</span
                    >
                  </div>
                </template>
              </v-tooltip>
            </v-row>
          </v-col>

          <v-col cols="1">
            <v-btn
              @click="filtrarContribuicoesDetalhada()"
              color="#004984"
              rounded
              outlined
              style="height: 100%; color: #f9f8f8"
              :disabled="!isVisaoSelectedDetalhada"
              :loading="isLoading"
            >
              Filtrar
            </v-btn>
          </v-col>
        </v-row>

        <!-- Corrigir estrutura -->
        <v-col
          v-if="currentViewDetalhada === 'Repositório' && repoDataDetalhada"
        >
          <v-row v-for="(repo, index) in repoDataDetalhada.data" :key="index">
            <h1 class="my-6" style="font-size: 18px; width: 100%">
              <v-icon>mdi-book</v-icon>
              Contribuições no Repositório: {{ repo.repoName }} / Branch:
              {{ repo.branch }}
              <v-icon>mdi-source-branch</v-icon>
            </h1>
            <v-row>
              <v-col cols="12">
                <h1 class="mb-2" style="font-size: 16px; width: 100%">
                  <v-icon>mdi-source-commit</v-icon>
                  Commits
                </h1>
                <v-data-table-server
                  items-per-page="5"
                  no-data-text="Sem commits para listar"
                  :headers="headersCommits"
                  :items="repo.commitsData"
                  :items-length="repo.totalItems"
                  :loading="repo.loadingCommits"
                  @update:options="
                    (options) => loadItems(repo, options, 'commits')
                  "
                >
                  <template v-slot:item.avatar="{ item }">
                    <v-avatar size="40">
                      <img
                        style="width: 100%"
                        :src="(item.value || item.selectable)?.avatar"
                      />
                    </v-avatar>
                  </template>
                  <template v-slot:item.name="{ item }">
                    <td>
                      {{ (item.value || item.selectable)?.name }}
                      <span class="text-medium-emphasis"
                        >(@{{
                          (item.value || item.selectable)?.teamMember
                        }})</span
                      >
                    </td>
                  </template>
                  <template v-slot:item.date="{ item }">
                    <td>
                      {{ pipeDate((item.value || item.selectable)?.date) }}
                    </td>
                  </template>
                </v-data-table-server>
              </v-col>
              <!-- <v-col cols="6">
                <h1 class="mb-2" style="font-size: 16px; width: 100%">
                  <v-icon>mdi-comment-outline</v-icon>
                  Comentários
                </h1>
                <v-data-table-server
                  items-per-page="5"
                  no-data-text="Sem comentários a listar"
                  :headers="headersCommits"
                  :items="repo.commentsData"
                  :items-length="totalItems"
                  @update:options="
                    (options) => loadItems(repo, options, 'comments')
                  "
                >
                  <template v-slot:item.avatar="{ item }">
                    <v-avatar size="40">
                      <img
                        style="width: 100%"
                        :src="(item.value || item.selectable)?.avatar"
                      />
                    </v-avatar>
                  </template>
                  <template v-slot:item.date="{ item }">
                    <td>
                      {{ pipeDate((item.value || item.selectable)?.date) }}
                    </td>
                  </template>
                </v-data-table-server>
              </v-col> -->
            </v-row>
          </v-row>
        </v-col>
        <v-col
          v-else-if="currentViewDetalhada === 'Membro' && membroDataDetalhada"
        >
          <v-row
            v-for="(membro, index) in membroDataDetalhada.data"
            :key="index"
          >
            <h1 class="my-6" style="font-size: 18px; width: 100%">
              <v-avatar size="28" style="margin-right: 5px">
                <img
                  :src="membro.avatar"
                  :alt="membro.teamMember"
                  class="icon-user"
                />
              </v-avatar>
              Contribuições do Usuário: {{ membro.teamMember }} / Branch:
              {{ membro.branch }}
              <v-icon>mdi-source-branch</v-icon>
            </h1>
            <v-row>
              <v-col cols="12">
                <h1 class="mb-2" style="font-size: 16px; width: 100%">
                  <v-icon>mdi-source-commit</v-icon>
                  Commits
                </h1>
                <v-data-table-server
                  items-per-page="5"
                  no-data-text="Sem commits para listar"
                  :headers="headersCommitsMembro"
                  :items="membro.commits"
                  :items-length="membro.totalItens"
                >
                  <template v-slot:item.date="{ item }">
                    <td>
                      {{ pipeDate((item.value || item.selectable)?.date) }}
                    </td>
                  </template>
                </v-data-table-server>
              </v-col>
            </v-row>
          </v-row>
        </v-col>
        <v-col v-else style="height: 50vh"></v-col>
      </v-window-item>
      <v-window-item :value="2" class="my-10">
        <!-- Descricao -->
        <v-row>
          <v-col>
            <p>
              Selecione as opções abaixo para visualizar as contribuições
              resumidas nos repositórios do projeto.
            </p>
          </v-col>
        </v-row>

        <!-- Filtros -->
        <v-row>
          <v-col>
            <v-row align="center">
              <v-col>
                <v-select
                  label="Visão"
                  v-model="visaoSelecionadaResumida"
                  :items="visao"
                  prepend-inner-icon="mdi-eye"
                  variant="solo"
                  rounded
                  clearable
                  hide-no-data
                  hide-details
                  return-object
                  @update:modelValue="onVisaoChangeResumida"
                ></v-select>
              </v-col>

              <v-tooltip text="Escolha uma visão" location="right">
                <template #activator="{ props }">
                  <v-icon v-bind="props" size="small">
                    mdi-information-outline
                  </v-icon>
                </template>
                <template #default>
                  <div class="custom-tooltip">
                    <span
                      >Defina uma visão para visualizar as contribuições do
                      Github.</span
                    >
                  </div>
                </template>
              </v-tooltip>
            </v-row>
          </v-col>

          <v-col>
            <v-row align="center">
              <v-col>
                <v-select
                  label="Repositórios"
                  :no-data-text="'Esse projeto não possui repositórios associados.'"
                  v-model="repositorioSelecionado"
                  :items="repositorios"
                  item-text="title"
                  item-value="repo"
                  prepend-inner-icon="mdi-book"
                  variant="solo"
                  rounded
                  clearable
                  hide-no-data
                  hide-details
                  :disabled="!isVisaoSelectedResumida"
                  @update:modelValue="onRepositorioChange"
                ></v-select>
              </v-col>

              <v-tooltip location="right">
                <template #activator="{ props }">
                  <v-icon v-bind="props" size="small">
                    mdi-information-outline
                  </v-icon>
                </template>
                <template #default>
                  <div class="custom-tooltip">
                    <span
                      >Quando o repositório não for selecionado, são
                      considerados <strong>todos</strong> os repositórios do
                      projeto.</span
                    >
                  </div>
                </template>
              </v-tooltip>
            </v-row>
          </v-col>

          <v-col>
            <v-row align="center">
              <v-col>
                <v-autocomplete
                  label="Desenvolvedores"
                  v-model="desenvolvedorSelecionado"
                  :items="
                    desenvolvedores.map((desenvolvedor) => ({
                      title: desenvolvedor.usuario_git,
                      image: desenvolvedor.img_url,
                    }))
                  "
                  prepend-inner-icon="mdi-account-search"
                  variant="solo"
                  rounded
                  clearable
                  hide-no-data
                  hide-details
                  :disabled="!isVisaoSelectedResumida"
                  item-value="title"
                >
                  <template v-slot:item="{ props, item }">
                    <v-list-item
                      v-bind="props"
                      open-on-clear
                      :prepend-avatar="item?.raw?.image"
                      :title="item?.raw?.title"
                    ></v-list-item>
                  </template>
                  <template #selection="{ item }">
                    <v-chip size="small">
                      <v-avatar size="18" style="margin-right: 5px">
                        <img
                          :src="item.raw.image"
                          alt="User Image"
                          class="icon-user"
                        />
                      </v-avatar>
                      <span>{{ item.title }}</span>
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-tooltip location="right">
                <template #activator="{ props }">
                  <v-icon v-bind="props" size="small">
                    mdi-information-outline
                  </v-icon>
                </template>
                <template #default>
                  <div class="custom-tooltip">
                    <span
                      >Quando o desenvolvedor não for selecionado, são
                      considerados <strong>todos</strong> os desenvolvedores do
                      projeto.</span
                    >
                  </div>
                </template>
              </v-tooltip>
            </v-row>
          </v-col>

          <v-col>
            <v-row align="center">
              <v-col>
                <VueDatePicker
                  v-model="date"
                  :disabled="!isVisaoSelectedResumida"
                  range
                  placeholder="Período"
                  auto-apply
                  :max-date="new Date()"
                  :enable-time-picker="false"
                  :format="format"
                />
              </v-col>
              <v-tooltip location="right">
                <template #activator="{ props }">
                  <v-icon v-bind="props" size="small">
                    mdi-information-outline
                  </v-icon>
                </template>
                <template #default>
                  <div class="custom-tooltip">
                    <span
                      >Caso não seja selecionado o período, é feita a busca
                      desde o início do projeto.</span
                    >
                  </div>
                </template>
              </v-tooltip>
            </v-row>
          </v-col>

          <v-col cols="1">
            <v-btn
              @click="filtrarContribuicoesResumida()"
              color="#004984"
              rounded
              outlined
              style="height: 100%; color: #f9f8f8"
              :disabled="!isVisaoSelectedResumida"
              :loading="isLoading"
            >
              Filtrar
            </v-btn>
          </v-col>
        </v-row>

        <v-col
          v-if="currentViewResumida === 'Repositórios' && combinedRepoData"
        >
          <v-row
            v-for="(repo, index) in combinedRepoData.repositories"
            :key="index"
          >
            <h1 class="my-6" style="font-size: 18px; width: 100%">
              <v-icon>mdi-book</v-icon>
              Contribuições no Repositório: {{ repo.name }}
            </h1>
            <v-row>
              <v-col cols="6" v-for="(user, index) in repo.users" :key="index">
                <v-tooltip location="end" class="user-stats">
                  <template #activator="{ props }">
                    <h1
                      v-bind="props"
                      class="mb-2"
                      style="font-size: 16px; display: inline-block"
                    >
                      <v-avatar size="28" style="margin-right: 5px">
                        <img
                          :src="user.avatar_url"
                          :alt="user.teamMember"
                          class="icon-user"
                        />
                      </v-avatar>
                      {{ user.teamMember }}
                    </h1>
                  </template>
                  <template #default>
                    <div>
                      <div v-if="user.userStats" style="color: #1d324b">
                        <p>
                          Estatísticas de
                          <strong>{{ user.teamMember }}</strong> no repositório
                          <strong>{{ repo.name }}</strong>
                        </p>
                        <v-icon color="#3EB983">mdi-source-commit</v-icon>
                        Commits: {{ user.userStats.commits }}<br />
                        <v-icon color="#3EB983">mdi-source-pull</v-icon> PRs
                        Abertos: {{ user.userStats.prOpened }}<br />
                        <v-icon color="#3EB983">mdi-source-pull</v-icon> PRs
                        Fechados: {{ user.userStats.prClosed }}<br />
                        <v-icon color="#3EB983">mdi-source-pull</v-icon> PRs
                        Revisados: {{ user.userStats.prReviewed }}<br />
                        <v-icon color="#3EB983"
                          >mdi-alert-circle-outline</v-icon
                        >
                        Issues Atribuídas: {{ user.userStats.issuesAssigned
                        }}<br />
                        <v-icon color="#3EB983"
                          >mdi-checkbox-marked-circle-outline</v-icon
                        >
                        Issues Resolvidas: {{ user.userStats.issuesResolved }}
                      </div>
                    </div>
                  </template>
                </v-tooltip>
                <v-data-table
                  items-per-page="5"
                  no-data-text="Sem branches para listar"
                  :headers="headersResumida"
                  :items="formatBranches(user.branches)"
                >
                  <template v-slot:item.commits="{ item }">
                    <td>
                      {{
                        (item.value || item.selectable).commits !== 0
                          ? (item.value || item.selectable).commits
                          : 'Nenhum commit'
                      }}
                    </td>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-row>
        </v-col>
        <v-col
          v-else-if="currentViewResumida === 'Membro' && membroDataResumida"
        >
          <v-row
            v-for="(membro, index) in membroDataResumida.membros"
            :key="index"
          >
            <h1 class="my-6" style="font-size: 18px; width: 100%">
              <v-avatar size="28" style="margin-right: 5px">
                <img
                  :src="membro.avatar_url"
                  :alt="membro.name"
                  class="icon-user"
                />
              </v-avatar>
              Contribuições do Usuário: {{ membro.name }}
            </h1>
            <v-row>
              <v-col
                cols="6"
                v-for="(repo, index) in membro.repositories"
                :key="index"
              >
                <h1 class="mb-2" style="font-size: 18px; width: 100%">
                  <v-icon>mdi-book</v-icon> {{ repo.nomeRepo }}
                </h1>
                <v-data-table
                  items-per-page="5"
                  no-data-text="Sem branches para listar"
                  :headers="headersResumida"
                  :items="formatBranches(repo.branches)"
                >
                  <template v-slot:item.commits="{ item }">
                    <td>
                      {{
                        (item.value || item.selectable).commits !== 0
                          ? (item.value || item.selectable).commits
                          : 'Nenhum commit'
                      }}
                    </td>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-row>
        </v-col>
        <v-col v-else style="height: 50vh"></v-col>
      </v-window-item>
    </v-window>
  </v-container>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import axios from 'axios';
import { VDataTableServer, VDataTable } from 'vuetify/labs/VDataTable';

import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

// import { VSkeletonLoader } from 'vuetify/labs/VSkeletonLoader';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    SnackBar,
    // VSkeletonLoader,
    VueDatePicker,
    VDataTableServer,
    VDataTable,
  },
  data: () => ({
    isLoading: false,
    idProjeto: null,
    visao: ['Repositórios', 'Membros'],
    visaoSelecionadaDetalhada: null,
    visaoSelecionadaResumida: null,
    repositorioSelecionado: null,
    branchesSelecionada: null,
    desenvolvedorSelecionado: null,
    periodoSelecionado: null,
    repositorios: [],
    branches: [],
    desenvolvedores: [],
    periodo: [],
    isVisaoSelectedDetalhada: false,
    isVisaoSelectedResumida: false,
    isRepositorioSelected: false,
    owner: null,
    date: null,
    format: (date) => {
      const since = date[0];
      const until = new Date(date[1]);

      const formatDate = (date) => {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
      };

      return `${formatDate(since)} - ${formatDate(until)}`;
    },
    repoDataDetalhada: null,
    membroDataDetalhada: null,
    repoDataResumida: null,
    membroDataResumida: null,
    userStats: null,
    // TODO: Talvez nada seja ordenavel
    headersCommits: [
      { title: '', key: 'avatar', sortable: false },
      { title: 'Nome', key: 'name' },
      { title: 'Mensagem', key: 'action' },
      { title: 'Data', key: 'date' },
    ],
    headersCommitsMembro: [
      { title: 'Repositório', key: 'repoName', sortable: false },
      { title: 'Mensagem', key: 'action', sortable: false },
      { title: 'Data', key: 'date', sortable: false },
    ],
    headersResumida: [
      { title: 'Branches', key: 'branch', sortable: false },
      { title: 'Commits', key: 'commits' },
    ],
    params: {},
    totalItems: 1000,
    loadingTable: true,
    tab: null,
    currentViewDetalhada: null,
    currentViewResumida: null,
  }),
  created() {
    this.owner = this.$store.state.org;
    this.idProjeto = this.$route.params.id;
    this.nomeProjeto = this.$route.params.nome;
    this.fetchRepositorios(this.$route.params.id);
    this.obterMembrosEquipe(this.$route.params.id);
  },
  computed: {
    combinedRepoData() {
      if (!this.repoDataResumida || !this.userStats) {
        return null;
      }

      const combinedData = JSON.parse(JSON.stringify(this.repoDataResumida));

      this.userStats.repositories?.forEach((statusRepo) => {
        const matchingRepo = combinedData.repositories?.find(
          (repo) => repo.name === statusRepo.name,
        );

        if (matchingRepo) {
          statusRepo.users?.forEach((statusUser) => {
            const matchingUser = matchingRepo.users?.find(
              (user) => user.teamMember === statusUser.teamMember,
            );

            if (matchingUser) {
              matchingUser.userStats = statusUser;
            }
          });
        }
      });

      return combinedData;
    },
  },
  methods: {
    fetchRepositorios(idProjeto) {
      this.messageRepo = '';
      axios
        .get(API_URL + `/projetos/${idProjeto}/repositorios`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          this.repositorios = response.data.map((repo) => ({
            title: repo.tb_repositorio.nome,
            repo: repo.tb_repositorio.nome,
          }));
        })
        .catch(() => {
          this.messageRepo = 'Sem repositórios a listar.';
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos buscar os repositórios!',
          );
        });
    },

    fetchBranches(owner, repo) {
      this.messageRepo = '';
      axios
        .get(API_URL + `/github-data/github/branches`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
          params: {
            organization: owner,
            repo,
          },
        })
        .then((response) => {
          this.branches = response.data;
        })
        .catch(() => {
          this.messageRepo = 'Sem branches a listar.';
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos buscar as branches!',
          );
        });
    },

    obterMembrosEquipe(idProjeto) {
      axios
        .get(`${API_URL}/equipes/projeto/${idProjeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          const membrosEquipe = response.data.tb_equipe.tb_membro;
          this.desenvolvedores = membrosEquipe.map(
            (membro) => membro.tb_usuario,
          );
        })
        .catch((error) => {
          console.error(error);
        });
    },

    onVisaoChangeDetalhada() {
      this.isVisaoSelectedDetalhada = !!this.visaoSelecionadaDetalhada;
    },

    onVisaoChangeResumida() {
      this.isVisaoSelectedResumida = !!this.visaoSelecionadaResumida;
    },

    onRepositorioChange() {
      console.log(this.repositorioSelecionado);
      if (this.repositorioSelecionado) {
        this.branchesSelecionada = null;
        this.fetchBranches(this.owner, this.repositorioSelecionado);
      }
      if (!this.repositorioSelecionado) {
        this.branchesSelecionada = null;
      }
      this.isRepositorioSelected = !!this.repositorioSelecionado;
    },

    filtrarContribuicoesDetalhada() {
      this.isLoading = true;
      this.params = {
        organization: this.owner,
        branch: this.branchesSelecionada || 'dev',
        page: 1,
        // eslint-disable-next-line
        per_page: 5,
      };

      if (this.repositorioSelecionado) {
        this.params.repo = this.repositorioSelecionado;
      }

      if (this.desenvolvedorSelecionado) {
        this.params.author = this.desenvolvedorSelecionado;
      }

      if (this.date) {
        const startDate = new Date(this.date[0]);
        const endDate = new Date(this.date[1]);

        // Ajuste para horário de Brasília (-3 horas)
        startDate.setUTCHours(0, 0, 0);
        endDate.setUTCHours(23, 59, 59);

        const since = startDate.toISOString().split('.')[0] + 'Z';
        const until = endDate.toISOString().split('.')[0] + 'Z';

        this.params.since = since;
        this.params.until = until;

        console.log('Since: ', since);
        console.log('Until: ', until);
      }

      if (this.visaoSelecionadaDetalhada === 'Repositórios') {
        this.consultarVisaoGeralRepositorios(this.params);
        this.currentViewDetalhada = 'Repositório';
      } else if (this.visaoSelecionadaDetalhada === 'Membros') {
        this.consultarVisaoGeralMembros(this.params);
        this.currentViewDetalhada = 'Membro';
      }
    },

    consultarVisaoGeralRepositorios(params) {
      axios
        .get(API_URL + `/github-data/geral-repositorio/${this.idProjeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
          params: params,
        })
        .then((response) => {
          this.repoDataDetalhada = response.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.messageRepo = 'Sem informações a listar.';
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos buscar as informações!',
          );
          this.isLoading = false;
        });
    },

    consultarVisaoGeralMembros(params) {
      axios
        .get(API_URL + `/github-data/geral-membro/${this.idProjeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
          params: params,
        })
        .then((response) => {
          this.membroDataDetalhada = response.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.messageRepo = 'Sem informações a listar.';
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos buscar as informações!',
          );
          this.isLoading = false;
        });
    },

    consultarCommits(repo, params) {
      axios
        .get(API_URL + `/github-data/github/commits/${this.idProjeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
          params: params,
        })
        .then((response) => {
          repo.commitsData = response.data.data[0].commitsData;
          repo.loadingCommits = false;
        })
        .catch((error) => {
          console.log('Erro ao consultar commits:', error);
          this.messageRepo = 'Sem informações a listar.';
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos buscar os commits dessa tabela.',
          );
        });
    },

    pipeDate(dateIso) {
      const date = new Date(dateIso);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },

    loadItems(repo, options, type) {
      if (type === 'commits') {
        repo.loadingCommits = true;
        this.params.repo = repo.repoName;
        this.params.page = options.page;
        // eslint-disable-next-line
        this.params.per_page = options.itemsPerPage;
        this.consultarCommits(repo, this.params);
      } else if (type === 'comments') {
        console.log('Click em comments');
      }
    },

    filtrarContribuicoesResumida() {
      this.isLoading = true;
      this.params = {
        owner: this.owner,
      };

      if (this.repositorioSelecionado) {
        this.params.repo = this.repositorioSelecionado;
      }

      if (this.desenvolvedorSelecionado) {
        this.params.author = this.desenvolvedorSelecionado;
      }

      if (this.date) {
        const startDate = new Date(this.date[0]);
        const endDate = new Date(this.date[1]);

        // Ajuste para horário de Brasília (-3 horas)
        startDate.setUTCHours(0, 0, 0);
        endDate.setUTCHours(23, 59, 59);

        const since = startDate.toISOString().split('.')[0] + 'Z';
        const until = endDate.toISOString().split('.')[0] + 'Z';

        this.params.since = since;
        this.params.until = until;

        console.log('Since: ', since);
        console.log('Until: ', until);
      }

      if (this.visaoSelecionadaResumida === 'Repositórios') {
        this.consultarVisaoResumida(this.params);
        this.consultarUserStats(this.params);
        this.currentViewResumida = 'Repositórios';
      } else if (this.visaoSelecionadaResumida === 'Membros') {
        this.consultarVisaoResumidaMembros(this.params);
        this.currentViewResumida = 'Membro';
      }
    },

    consultarVisaoResumida(params) {
      axios
        .get(API_URL + `/github-data/resumida-repositorio/${this.idProjeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
          params: params,
        })
        .then((response) => {
          this.repoDataResumida = response.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.messageRepo = 'Sem informações a listar.';
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos buscar as informações!',
          );
          this.isLoading = false;
        });
    },

    consultarVisaoResumidaMembros(params) {
      axios
        .get(API_URL + `/github-data/resumida-membro/${this.idProjeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
          params: params,
        })
        .then((response) => {
          this.membroDataResumida = response.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.messageRepo = 'Sem informações a listar.';
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos buscar as informações!',
          );
          this.isLoading = false;
        });
    },

    consultarUserStats(params) {
      axios
        .get(API_URL + `/github-data/user-stats/${this.idProjeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
          params: params,
        })
        .then((response) => {
          this.userStats = response.data;
        })
        .catch(() => {
          this.messageRepo = 'Não foi possível buscar as estatísticas.';
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos buscar as estatísticas dos usuários!',
          );
        });
    },

    formatBranches(branches) {
      return Object.entries(branches).map(([branch, commits]) => ({
        branch,
        commits,
      }));
    },
  },
};
</script>

<style scoped>
.flex-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.contribuicao-text {
  font-size: 22px;
  font-weight: bold;
}
.skeleton-wrapper {
  width: 50%;
  background: transparent;
}
.custom-tooltip {
  width: 250px;
}
.icon-user {
  width: 100%;
}
.date-picker {
  border-radius: 50px;
}
.dp__theme_light {
  --dp-border-radius: 40px;
  --dp-input-padding: 15px 30px 15px 12px;
  --dp-cell-border-radius: 40px; /*Specific border radius for the calendar cell*/
  --dp-font-family: 'Poppins', sans-serif;
  -webkit-border-radius: 40px;
  box-shadow: 0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)),
    0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)),
    0px 1px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.12));
  --dp-border-color: none;
  --dp-disabled-color: #fbfbfb;
}
/* :deep(.v-input__control) {
  background: white;
  border-radius: 30px;
} */
v-tab {
  font-size: 16px;
  padding: 0;
  text-transform: unset;
  padding-right: 16px;
  font-weight: bold;
}
.user-stats :deep(.v-overlay__content) {
  background: white;
  border: 1px solid black;
}
</style>
